import React from 'react';
import ReactDOM from 'react-dom';
import DMS from './route';

ReactDOM.render(<DMS />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js